import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/shopDetails/:lang/:params',
    name: 'shopDetails',
    component: () => import('@/views/ShopDetailsComponent.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
